import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { classeursService, fichiersService } from "../../services";
import { showToast } from "..";
import { useAuth } from "../../utils/UserProvider";
import { Fichier } from "../../interfaces/fichier";
import { useQuery, useQueryClient } from "@tanstack/react-query";


interface FormCorrespondanceFichierProps {
  closeModalCorrespondance: () => void;
  selectedFiles: Fichier[];
  setSelectedFiles: any;
  setLoading: (newvalue: boolean) => void;
}
const FormCorrespondanceFichier = ({
  closeModalCorrespondance,
  selectedFiles,
  setSelectedFiles,
  setLoading,
}: FormCorrespondanceFichierProps) => {
  const queryClient = useQueryClient();
  const [selectedClasseur, setSelectedClasseur] = useState(null);
  const { user,client } = useAuth();
  const [extractDPE, setExtractDPE] = useState(false);

  const { data: classeurs } = useQuery({
    queryKey: ["classeurs", user.id],
    queryFn: async () => classeursService.getAllByUser(user.id),
  });
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const fileIds = selectedFiles.map((file) => file.id);
      const datafichier = {
        classeur_id: data.classeur_id,
        file_ids: fileIds,
        extract:extractDPE,
        env_client_id:client.id
      };
      setLoading(true);
      await fichiersService.correspondanceFichier(datafichier).then(() => {
        setLoading(false);
        showToast("success", "Correspondance effectué avec succès");
        queryClient.refetchQueries({
          queryKey: ["fichiers"],
        });
        reset();
        closeModalCorrespondance();
        setSelectedFiles([]);
      });
    } catch (e) {
      console.log("Error while fetching", e);
    }
  };

  useEffect(() => {
    if (selectedFiles.length === 0) {
      closeModalCorrespondance();
    }
  }, [selectedFiles]);

  const onRemoveFile = (index) => {
    const updatedFiles = [...selectedFiles];
    updatedFiles.splice(index, 1);
    setSelectedFiles(updatedFiles);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <div className="col-span-6 sm:col-span-6">
          <div className="p-6 bg-white border border-gray-200 rounded-lg shadow ">
            <ul className=" max-h-64 overflow-y-auto space-y-2 ">
              {selectedFiles.map((file, index) => (
                <li key={index} className="pb-3 sm:pb-4">
                  <div className="flex items-center space-x-2">
                    <div className="flex-shrink-0">
                      <img
                        className=" w-6 h-6"
                        src="/images/fichier.png"
                        alt="fichier"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h1 className="text-md font-semibold text-gray-700 capitalize">
                        {file.nom_fichier}
                      </h1>
                    </div>
                    <button
                      type="button"
                      onClick={() => onRemoveFile(index)}
                      className="inline-flex items-center px-4 py-2 bg-white-600 hover:bg-white-700 text-black text-sm font-medium rounded-md"
                    >
                      x
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="col-span-6 sm:col-span-6 mt-5">
          <label
            htmlFor="classeur_id"
            className="block text-md font-bold leading-6 text-gray-900"
          >
            Choisir votre classeur:
          </label>

          <select
            name="classeur_id"
            id="classeur_id"
            className="  my-3 border border-gray-300 text-gray-900 font-bold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
            {...register("classeur_id", {
              required: true,
            })}
            onChange={(e) => {
              setSelectedClasseur(e.target.value);
            }}
          >
            <option value={""}>Choisir votre classeur</option>
            {classeurs?.map((classeur) => (
              <option key={classeur.id} value={classeur.id}>
                {classeur.nom_classeur} —{" "}
                {new Date(classeur.created_at).toLocaleDateString("fr-FR", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })}
                {classeur.actifs && classeur.actifs.length > 0
                ? ` — ${classeur.actifs
                    .slice(0, 1)
                    .map((a) => a.nom_actif)
                    .join(", ")}${classeur.actifs.length > 1 ? ` +${classeur.actifs.length - 1}` : ""}`
                : " — —"}
              </option>
            ))}
          </select>
          {errors.classeur_id && (
            <span className="bg-red-100 text-red-800 text-sm font-medium mr-2 mt-2  px-2 py-1 rounded ">
              champs obligatoire
            </span>
          )}
        </div>
         {selectedClasseur &&(
          <div className="mt-4 flex items-center space-x-3">
          
            <label
              htmlFor="classeur_id"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Extraire des données pour ce(s) fichier(s) ?  
            </label>
            <input
              type="checkbox"
              id="extractDPE"
              checked={extractDPE}
              onChange={(e) => setExtractDPE(e.target.checked)}
              className="h-5 w-5 text-gexpertise-200 focus:ring-gexpertise-100 border-gray-300 rounded"
            />
          </div>
          )}
        <div className="flex justify-end space-x-2 mt-5">
          <button
            type="submit"
            className="text-white bg-gexpertise-200 hover:bg-gexpertise-100 font-medium rounded-lg text-sm px-6 py-3  text-center "
          >
            Confirmer
          </button>
          <button
            type="button"
            onClick={() => {
              closeModalCorrespondance();
              reset();
              setSelectedClasseur(null);
              setSelectedFiles([]);
            }}
            className="text-gray-600 border border-gray-600 bg-white hover:bg-gray-100 font-medium rounded-lg text-sm px-6 py-3  text-center "
          >
            Annuler
          </button>
        </div>
      </form>
    </>
  );
};

export default FormCorrespondanceFichier;
